import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PreQualificationApplicationRequest, PreQualificationApplicationResponse, PreQualificationApplicationsPage } from '../models/prequal.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PreQualService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/PreQualificationApplications`;

  submitApplication(data: PreQualificationApplicationRequest): Observable<PreQualificationApplicationResponse> {
    console.log('Sending PreQual application:', data);
    return this.http.post<PreQualificationApplicationResponse>(this.apiUrl, data);
  }

  getApplications(pageNumber: number = 1, pageSize: number = 10): Observable<PreQualificationApplicationsPage> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    return this.http.get<PreQualificationApplicationsPage>(this.apiUrl, { params });
  }

  getApplicationById(id: number): Observable<PreQualificationApplicationResponse> {
    return this.http.get<PreQualificationApplicationResponse>(`${this.apiUrl}/${id}`);
  }
}